import $ from 'jquery'
import { arrayToSentence } from '@app/utils/string-helpers'

$(document).on('turbolinks:load', (_e) =>
  $('[data-behaviour~="submit-with-duplicate"]').each(function () {
    const names = JSON.parse($(this).attr('data-names'))
    return window.sfConfirm({
      question: I18n.t('confirmation.duplicate_name'),
      message: I18n.t('confirmation.duplicate_name_details', {
        names: arrayToSentence(names),
        count: names.length,
      }),
      keep: true,
      onConfirm: () => {
        const target = $(this).attr('data-target')
        const form = $(target)
        $('<input />')
          .attr('type', 'hidden')
          .attr('name', 'allow_dup_name')
          .attr('value', true)
          .appendTo(target)
        return form.submit()
      },
    })
  })
)
